const sections = document.querySelectorAll('.js-report-content');
const input = document.querySelector('.js-input');
const plus = document.querySelectorAll('.js-plus');
const dash = document.querySelectorAll('.js-dash');


	document.addEventListener('keyup', () => {
		sections.forEach((section, index) => {
			let showSection = false;
			Array.from(section.children).forEach((child) => {
				Array.from(child.children).forEach((secondaryChild) => {

					if(
						secondaryChild.tagName !== "DIV" && secondaryChild.nextElementSibling?.querySelectorAll('a').length === 0 && input?.value.length >= 3) {
						child.classList.add('hidden');
						secondaryChild.nextElementSibling?.classList.add('hidden');
						secondaryChild.classList.add('hidden');

					} else if (secondaryChild.tagName !== "DIV" && secondaryChild.nextElementSibling?.querySelectorAll('a').length > 0 || input?.value.length < 3) {
					
						child.classList.remove('hidden');
						secondaryChild.nextElementSibling?.classList.remove('hidden');
						secondaryChild.classList.remove('hidden');
						showSection = true;
					}

					if (secondaryChild.children.length > 0 && input?.value.length >= 3) {
						secondaryChild.children[0].tagName == "svg" ? child.classList.add('hidden') : null;
					} else if (secondaryChild.children.length > 0 && input?.value.length >= 3) {
						secondaryChild.children[0].tagName == "svg" ? child.classList.remove('hidden') : null;
					}
				});
			});

			if ( input.value.length >= 3) {
				plus[index].style.display = 'none';
				dash[index].style.display = 'block';
			} else if (input.value.length < 3) {
				plus[index].style.display = 'block';
				dash[index].style.display = 'none';
			}
		});
	});